const { scrollmagic } = require("./modules/scrollmagic");
const { pageTop } = require("./modules/pageTop");
const { smooth } = require("./modules/smooth");
const { modal } = require("./modules/modal");
const { collapse } = require("./modules/collapse");

scrollmagic();
pageTop();
smooth();
modal();
collapse();
